export * from './IframeBlock';

import { IframeBlock } from './IframeBlock';

export default IframeBlock;
